import React, { ReactElement } from "react";

// Material-UI
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";

const OCKeyboardKeyIcon = styled("div")(({ theme }) => ({
  width: "fit-content",
  display: "block",
  "& .key_button": {
    padding: "6px 10px",
    boxSizing: "border-box",
    lineHeight: "16px",
    fontSize: 14,
    textAlign: "center",
    color: theme.palette.primary.main,
    cursor: "pointer",
    borderColor: theme.palette.common.black,
    borderStyle: "solid",
    textShadow: "0 0.5px 1px #777, 0 1px 3px" + theme.palette.common.white,
    borderWidth: 1,
    borderRadius: 10,
    background: "linear-gradient(top, #f9f9f9 0%, #B2B2B2 50%, #a0a0a0 100%)",
    fontFamily: "sans-serif",
    display: "inline-block",
    transition: "box-shadow 0.3s ease, transform 0.15s ease",
    minHeight: "28px",
    minWidth: "40px",
  },
}));

/**
 *
 * @param key -: string
 * @returns an icon matching to the key | it just returns an icon with the content being the string passed in
 */
const returnIcon = (key: string): ReactElement | string => {
  switch (key) {
    case "0":
      return <SwapHorizIcon className="key_button" />;
    default:
      return <div className="key_button">{key}</div>;
  }
};

/**
 *
 * @param keyCode - takes in a keyboard key code
 * @returns a keyboard key icon
 */
export const KeyboardKeyIcon = (keyCode: string): JSX.Element => {
  const theme = useTheme();
  return <OCKeyboardKeyIcon>{returnIcon(keyCode)}</OCKeyboardKeyIcon>;
};
